import { Error } from "./error";
import { ClassRef } from "./types";


export { Error };


// export class AggregateError extends Error
// {
//     constructor(message: string, innerErrors: globalThis.Error[])
//     {
//         super(message);
//     }
// }


export class ArgumentError extends Error
{
}

ClassRef.define(ArgumentError, "ArgumentError");


export class ForbiddenError extends Error
{
}

ClassRef.define(ForbiddenError, "ForbiddenError");


export class InvalidOperationError extends Error
{
}

ClassRef.define(InvalidOperationError, "InvalidOperationError");


export class NotAvailableError extends Error
{
}

ClassRef.define(NotAvailableError, "NotAvailableError");


export class NotFoundError extends Error
{
}

ClassRef.define(NotFoundError, "NotFoundError");


export class NotImplementedError extends Error
{
}

ClassRef.define(NotImplementedError, "NotImplementedError");


export class NotSupportedError extends Error
{

}

ClassRef.define(NotSupportedError, "NotSupportedError");


export class UnauthorizedAccessError extends Error
{
}

ClassRef.define(UnauthorizedAccessError, "UnauthorizedAccessError");


export class UnhandledError extends Error
{
}

ClassRef.define(UnhandledError, "UnhandledError");
